import { useMemo, memo } from 'react';

import clsx from 'clsx';
import { isWeekend, isToday } from 'date-fns';
import Holidays from 'date-holidays';

import IconHoliday from '@ui/components/icons/IconHoliday';
import { formatCsDayWithNumber } from '@utils/formatCs';

interface DayDateTextationProps {
  date: Date;
}

const DayDateTextation = ({ date }: DayDateTextationProps) => {
  const czechHolidays = useMemo(() => new Holidays('CZ'), []);
  const holidays = useMemo(
    () => czechHolidays.isHoliday(date),
    [czechHolidays, date],
  );

  const isPublicHoliday = useMemo(
    () => holidays && holidays.some((holiday) => holiday.type === 'public'),
    [holidays],
  );

  const today = isToday(date);
  const weekend = isWeekend(date);

  return (
    <span
      className={clsx(
        'mr-1 flex h-[48px] w-[76px] flex-[0_0_76px] items-center justify-center rounded-2xl border-2 text-[12px]/[16px] capitalize',
        weekend ? 'font-bold' : 'font-medium',
        today
          ? 'border-brand-primary-300 text-brand-primary-100'
          : 'border-brand-transparent-100 text-brand-gray-100',
      )}
    >
      {`${today ? 'Dnes' : formatCsDayWithNumber(date)}`}{' '}
      {isPublicHoliday && holidays && (
        <IconHoliday
          holiday={holidays[0].name}
          className="ml-[8px] fill-brand-primary-100"
        />
      )}
    </span>
  );
};

export default memo(DayDateTextation, (prev, next) => prev.date === next.date);
